import { render } from "./ReceiptContent.vue?vue&type=template&id=5a2bb889"
import script from "./ReceiptContent.vue?vue&type=script&lang=js"
export * from "./ReceiptContent.vue?vue&type=script&lang=js"

import "./ReceiptContent.vue?vue&type=style&index=0&id=5a2bb889&scope=true&lang=css"

import exportComponent from "/Users/nakarinjaiseengam/Works/STM/STM-POS/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__